"use client";
import Button from "@/common/Button";
import Image from "next/image";
import { useRouter } from "next/navigation";
import React from "react";

function ErrorPage() {
  const router = useRouter();
  const backHandler = () => {
    router.back();
  };
  return (
    <div className="lg:px-16 px-6 min-h-[calc(100vh-60px)] flex flex-col justify-center items-center">
      <div className="sm:w-150 sm:h-75 w-auto h-auto">
        <Image
          priority
          fetchPriority="high"
          sizes="100vw"
          className="w-full h-full object-cover"
          src="/images/404.png"
          width={1000}
          height={1000}
          alt="404 error"
          unoptimized
        />
      </div>
      <span className="sm:text-4xl text-xl mt-10">صفحه مورد نظر یافت نشد</span>
      <Button
        type="button"
        onClick={backHandler}
        className="bg-ws-white-100 border-2 border-black px-10 py-3 rounded-full text-black mt-10"
      >
        بازگشت
      </Button>
    </div>
  );
}

export default ErrorPage;
